/** HTTP status from an axios-style error, or null when the request never got a response. */
export function getHttpStatus(error: unknown): number | null {
	const status = (error as { response?: { status?: unknown } } | null | undefined)?.response?.status;
	return typeof status === "number" ? status : null;
}
